import React, { useState, useEffect } from 'react';
import { Container, Alert } from "react-bootstrap";
import { LanguageProvider } from '../../../core/language-provider';
import { DataManager } from '../../../core/data-manager';
import ZoomMtgEmbedded from "@zoom/meetingsdk/embedded";
import moment from 'moment';
import { ApiManager } from '../../../core/api-manager';
import Vimeo from '@u-wave/react-vimeo';


export default function VideoPlayer({ episode }) {

    const [data, setData] = useState(null);
    const [errors, setErrors] = useState('');
    const [accessToken, setAccessToken] = useState(null);
    const clientId = "EaDQBGaCTiGvLoxYYcdyaQ";
    const clientSecret = "2QNeL7ss2AC5uZpprsmcRG5J911EiUiB";
    const accountId = "7006005098";


    useEffect(() => {
        init()
    }, [episode]);


    async function init() {
        if (episode && episode.idVideo) {
            var response = await DataManager.getItem('episode_video', episode.idVideo)
            console.warn('episode_video', response)
            if (response.success === 1) {
                let b = response.body[0]
                console.log(b)
                setData(b)
            }
            else {
                setErrors(LanguageProvider.get('errors.get'))
                console.warn(response)
            }
        }
    }

    /* async function getZoomToken() {
        var response = await ApiManager.sendAuthenticatedRequest('/custom/get_zoom_authToken');
        console.warn(response)
        var token = response;
        setAccessToken(token)

        var records = await fetchRecordings(token)
        console.warn(records)
    } */

    /* const fetchRecordings = async (accessToken) => {
        const url = 'https://api.zoom.us/v2/meetings/FYuF0ffPRuO7g7WNZb0Y6g/recordings';
        const options = { method: 'GET', headers: { Authorization: 'Bearer K8XCANDpQKm1zJl4NOZ0Vw' } };

        try {
            const response = await fetch(url, options);
            const data = await response.json();
            console.log(data);
        } catch (error) {
            console.error(error);
        }
    }; */






    if (data !== null) {

        return (
            <>
                {errors.length > 0 &&
                    <Alert variant='danger mt-5'>
                        {errors}
                    </Alert>
                }


                <Container fluid='md' className='text-center' style={{ 'maxWidth': 900 }}>
                    {data.link.includes("vimeo") ? (
                        <Vimeo
                            video={data.link}
                            autoplay
                            width="100%"
                            responsive={true}
                            crossorigin="anonymous"
                        />
                    ) : (
                        <iframe
                            src={data.link}
                            width="900"
                            height="750"
                            allow="autoplay"
                            frameBorder="0"
                            allowFullScreen={true}
                            crossorigin="anonymous"
                        ></iframe>
                    )}
                </Container>
            </>
        );
    }
};